<template>
  <div>
    <div class="trending-area fix">
      <div class="container">
        <div class="trending-main">
          <div class="row">
            <div class="col-lg-3 d-xs-none" style="font-size: 12px!important;">
              <!-- Category -->
              <div class="category mb-30">
                <div class="category__title">
                  <h4><i class="fas fa-list-ul"></i>Danh mục tài sản</h4>
                </div>
                <div class="category__list">
                  <a class="category__item" href="#">
                    QUYỀN SỬ DỤNG ĐẤT ĐỂ GIAO ĐẤT HOẶC CHO THUÊ ĐẤT
                  </a>
                  <a class="category__item" href="#">
                    TÀI SẢN LÀ NỢ XẤU VÀ TÀI SẢN BẢO ĐẢM TẠI TỔ CHỨC TÍN DỤNG
                  </a>
                  <a class="category__item" href="#">
                    TÀI SẢN THI HÀNH ÁN
                  </a>
                  <a class="category__item" href="#">
                    TÀI SẢN LÀ TANG VẬT, PHƯƠNG TIỆN VI PHẠM HÀNH CHÍNH HOẶC TÀI SẢN KÊ BIÊN
                  </a>
                  <a class="category__item" href="#">
                    TÀI SẢN NHÀ NƯỚC
                  </a>
                  <a class="category__item" href="#">
                    CÁC LOẠI TÀI SẢN KHÁC
                  </a>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="carousel zippy-carousel transition">
                <div class="inner">
                  <carousel
                    :paginationPosition="'top-overlay'"
                    :per-page="1"
                    :autoplay="true"
                    :loop="true"
                    :autoplayTimeout="3000"
                  >
                    <slide>
                      <img style="width:100%;height: 100%;" src="@/assets/images/838b4325c8a132ff6bb0.jpg" />
                    </slide>
                    <slide>
                      <img style="width:100%;height: 100%;" src="@/assets/images/fdaf5a3571b28becd2a3.jpg" />
                    </slide>
                    <slide>
                      <img style="width:100%;height: 100%;" src="@/assets/images/sep.jpg" />
                    </slide>
                    <slide>
                      <img style="width:100%;height: 100%;" src="@/assets/images/thu truong B.jpg" />
                    </slide>
                  </carousel>
                </div>
              </div>
            </div>
            <!-- Riht content -->
            <div class="col-lg-3">
              <!-- Category -->
              <div class="support mb-30">
                <div class="support__title">
                  <h4>HỖ TRỢ:</h4>
                </div>
                <div class="support__list">
                  <a href="#"><i class="fas fa-headphones"></i> Hotline: 0243.7622619</a>
                  <a href="#">Email: daugiatructuyen.nalaf@gmail.com</a>
                </div>
                <div class="support__title">
                  <h4>HƯỚNG DẪN:</h4>
                </div>
                <div class="support__list">
                  <a href="/files/huong_dan_su_dung.pdf" target="_blank">Hướng dẫn tham gia đấu giá</a>
                  <a href="/files/nguoi_co_tai_san.pdf" target="_blank">Hướng dẫn người có tài sản</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <section class="whats-news-area pt-50 pb-20">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="row d-flex justify-content-between">
              <div class="col-lg-12 col-md-12">
                <div class="properties__button">
                  <nav-item-block>
                    TIN TỨC NỔI BẬT VỀ ĐẤU GIÁ TRỰC TUYẾN
                  </nav-item-block>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <!-- Nav Card -->
                <div class="tab-content" id="nav-tabContent">
                  <!-- card one -->
                  <div
                    style="line-height: 23px;"
                    class="tab-pane fade show active"
                    id="nav-home"
                    role="tabpanel"
                    aria-labelledby="nav-home-tab"
                  >
                    <div class="whats-news-caption">
                      <div class="row">
                        <div v-for="i in newsData" :key="i.Id" class="col-lg-6 col-md-6 col-sm-12">
                          <a v-on:click="$router.push('/news/' + i.Id)" v-if="i.LoaiNoiDung == 0" target="_blank">
                            - {{ i.TrichDan }}.
                          </a>
                          <a v-else-if="i.LoaiNoiDung == 1" :href="i.DuongDan" target="_blank"> - {{ i.TrichDan }}. </a>
                          <a v-else-if="i.LoaiNoiDung == 2" :href="i.File" target="_blank"> - {{ i.TrichDan }}. </a>
                        </div>
                      </div>
                      <div class="row"></div>
                    </div>
                  </div>
                </div>
                <!-- End Nav Card -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="whats-news-area pb-20">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="row d-flex justify-content-between">
              <div class="col-lg-12 col-md-12">
                <div class="properties__button">
                  <nav-item-block>
                    PHIÊN ĐẤU GIÁ
                    <app-button
                      slot="extra"
                      @click="onViewAllAuction"
                      class="view-all-top"
                      v-if="auctionDoData.length > 0"
                    >
                      Xem tất cả
                      <i class="ml-1 fas fa-chevron-right" slot="icon" />
                    </app-button>
                  </nav-item-block>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <app-loading :loading="isLoadingAuction" />
                <!-- Nav Card -->
                <div class="tab-content" id="nav-tabContent" v-if="!isLoadingAuction && auctionDoData.length > 0">
                  <!-- card one -->
                  <div class="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
                    <div class="whats-news-caption">
                      <auction-list :data="auctionDoData" />
                    </div>
                  </div>
                </div>
                <empty v-else description="Không tìm thấy phiên đấu giá nào" />
                <div class="view-all" v-if="auctionDoData.length > 0">
                  <app-button slot="extra" @click="onViewAllAuction">
                    Xem tất cả
                    <i class="ml-1 fas fa-chevron-right" slot="icon" />
                  </app-button>
                </div>
                <!-- End Nav Card -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="whats-news-area pb-20">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="row d-flex justify-content-between">
              <div class="col-lg-12 col-md-12">
                <div class="properties__button">
                  <nav-item-block>
                    THÔNG TIN MỜI THAM GIA ĐẤU GIÁ – TÀI SẢN ĐẤU GIÁ
                    <app-button
                      slot="extra"
                      @click="onViewAllNewsNotify"
                      class="view-all-top"
                      v-if="notifyData.length > 0"
                    >
                      Xem tất cả
                      <i class="ml-1 fas fa-chevron-right" slot="icon" />
                    </app-button>
                  </nav-item-block>
                </div>
              </div>
            </div>
            <app-loading :loading="isLoadingNotify" />
            <news-notify-auction-list :data="notifyData" v-if="!isLoadingNotify && notifyData.length > 0" />
            <empty v-else description="Không tìm thấy thông tin mời tham gia đấu giá nào" />
            <div class="view-all">
              <app-button slot="extra" @click="onViewAllNewsNotify">
                Xem tất cả
                <i class="ml-1 fas fa-chevron-right" slot="icon" />
              </app-button>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="whats-news-area pb-20">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="row d-flex justify-content-between">
              <div class="col-lg-12 col-md-12">
                <div class="properties__button">
                  <nav-item-block>
                    KIẾN THỨC PHÁP LUẬT
                  </nav-item-block>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <!-- Nav Card -->
                <div class="tab-content" id="nav-tabContent">
                  <!-- card one -->
                  <div
                    style="line-height: 23px;"
                    class="tab-pane fade show active"
                    id="nav-home"
                    role="tabpanel"
                    aria-labelledby="nav-home-tab"
                  >
                    <div class="whats-news-caption">
                      <div class="row">
                        <div class="col-lg-6 col-md-6 col-sm-12" v-for="item in legalKnowledge" :key="item.id">
                          <a target="_blank" :href="item.link">- {{ item.title }}</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- End Nav Card -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section style="display: none;" class="whats-news-area pt-50 pb-20">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="row d-flex justify-content-between">
              <div class="col-lg-12 col-md-12">
                <div class="properties__button">
                  <nav-item-block>
                    Quy định pháp luật đấu giá
                  </nav-item-block>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <!-- Nav Card -->
                <div class="tab-content" id="nav-tabContent">
                  <!-- card one -->
                  <div class="tab-pane fade show active" id="nav-4" role="tabpanel" aria-labelledby="nav-4-tab">
                    <div class="row">
                      <div class="col-12">
                        <div class="home-news">
                          <a
                            href="http://vbpl.vn/botuphap/Pages/vbpq-toanvan.aspx?ItemID=122824&Keyword="
                            target="_blank"
                            >Thông tư 06/2017/TT-BTP</a
                          >
                          <a
                            href="http://vbpl.vn/botuphap/Pages/vbpq-toanvan.aspx?ItemID=17067&Keyword="
                            target="_blank"
                            >Luật giao địch điện tử</a
                          >
                          <a href="http://vbpl.vn/TW/Pages/vbpq-toanvan.aspx?ItemID=15066" target="_blank"
                            >Luật công nghệ thông tin</a
                          >
                          <a href="http://vbpl.vn/botuphap/Pages/vbpq-van-ban-goc.aspx?ItemID=30470" target="_blank"
                            >Nghị định 52/2013/NĐ-CP</a
                          >
                          <a href="http://vbpl.vn/TW/Pages/vbpq-van-ban-goc.aspx?ItemID=105747" target="_blank"
                            >Thông tư 59/2015/TT-BCT</a
                          >
                          <a href="http://vbpl.vn/bocongthuong/Pages/vbpq-van-ban-goc.aspx?ItemID=46686" target="_blank"
                            >Thông tư 12/2013/TT-BCT</a
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- End Nav Card -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section style="display: none;" class="whats-news-area pt-50 pb-20">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="row d-flex justify-content-between">
              <div class="col-lg-12 col-md-12">
                <div class="properties__button">
                  <nav-item-block>
                    Thông báo đấu giá
                  </nav-item-block>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <!-- Nav Card -->
                <div class="tab-content" id="nav-tabContent">
                  <!-- Card two -->
                  <div class="tab-pane fade show active" id="nav-5" role="tabpanel" aria-labelledby="nav-5-tab">
                    <div class="row">
                      <div class="col-12">
                        <div class="home-news">
                          <a href="#">Thông báo đấu giá tài sản Ô tô</a>
                          <a href="#">Thông báo đấu giá tài sản Đất</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- End Nav Card -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section style="display: none;" class="whats-news-area pt-50 pb-20">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="row d-flex justify-content-between">
              <div class="col-lg-12 col-md-12">
                <div class="properties__button">
                  <nav-item-block>
                    Thủ tục sau đấu giá
                  </nav-item-block>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <!-- Nav Card -->
                <div class="tab-content" id="nav-tabContent">
                  <!-- Card three -->
                  <div class="tab-pane fade show active" id="nav-6" role="tabpanel" aria-labelledby="nav-6-tab">
                    <div class="row">
                      <div class="col-lg-3 col-md-3 col-xs-12">
                        <div class="home-card">
                          <a href="#" alt="">
                            <img src="@/assets/images/kq.png" alt="" />
                            <span class="home-card__link">
                              Kết quả đấu giá
                            </span>
                          </a>
                        </div>
                      </div>
                      <div class="col-lg-3 col-md-3 col-xs-12">
                        <div class="home-card">
                          <a href="#" alt="">
                            <img src="@/assets/images/hd.jpg" alt="" />
                            <span class="home-card__link">
                              Hợp đồng mua bán tài sản
                            </span>
                          </a>
                        </div>
                      </div>
                      <div class="col-lg-3 col-md-3 col-xs-12">
                        <div class="home-card">
                          <a href="#" alt="">
                            <img src="@/assets/images/nh.jpg" alt="" />
                            <span class="home-card__link">
                              Bàn giao tài sản
                            </span>
                          </a>
                        </div>
                      </div>
                      <div class="col-lg-3 col-md-3 col-xs-12">
                        <div class="home-card">
                          <a href="#" alt="">
                            <img src="@/assets/images/ship.jpg" alt="" />
                            <span class="home-card__link">
                              Hỗ trợ giao hàng
                            </span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- End Nav Card -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { Carousel, Slide } from 'vue-carousel';

import ImageAvata from '@/components/ImageAvata';
import mixin from '@/mixins/mixin.js';
import Auction from '@/common/api/auction';
import News from '@/common/api/news';
import CONFIG from '@/common/config';
import AuctionItem from '@/components/Dashboard/AuctionItem.vue';
import NavItemBlock from '@/components/NavItemBlock.vue';
import NewsNotifyAuctionList from '@/components/Dashboard/NewsNotifyAuctionList.vue';
import AppButton from '@/components/AppButton.vue';
import AuctionList from '@/components/Dashboard/AuctionList.vue';
import AppLoading from '@/components/AppLoading.vue';
import Empty from '@/components/Empty.vue';

import legalKnowledge from '@/data/legal-knowledge.json';

export default {
  name: 'Dashboard',
  mixins: [mixin],
  components: {
    Carousel,
    Slide,
    ImageAvata,
    AuctionItem,
    NavItemBlock,
    NewsNotifyAuctionList,
    AppButton,
    AuctionList,
    AppLoading,
    Empty
  },
  data() {
    return {
      messLogin: '',
      username: '',
      password: '',
      tab: 1,
      newsData: [],
      notifyData: [],
      auctionDoData: [],
      list_type_auction: {
        do: CONFIG.ID_AUCTION_DO,
        doing: CONFIG.ID_AUCTION_DOING,
        done: CONFIG.ID_AUCTION_DONE
      },
      type_auction: CONFIG.ID_AUCTION_DOING,
      isLoadingAuction: false,
      isLoadingNews: false,
      isLoadingNotify: false,
      legalKnowledge
    };
  },
  computed: {
    ...mapGetters(['currentUser', 'isAuthenticated'])
  },
  created() {
    this.getListAuctionDo();
    this.getNewsNotify();
    this.getNews();
  },
  methods: {
    getNewsNotify() {
      this.isLoadingNotify = true;
      News.getNewsAuctionPaging({ pageSize: 10, pageIndex: 1 })
        .then(({ data }) => {
          if (data.Status === 200) {
            this.notifyData = data.Data.Data;
          }
        })
        .finally(() => {
          this.isLoadingNotify = false;
        });
    },
    getNews() {
      this.isLoadingNews = true;
      News.getNewsPaging({ pageSize: 10000, pageIndex: 1 })
        .then(({ data }) => {
          if (data.Status === 200) {
            this.newsData = data.Data.Data;
          }
        })
        .finally(() => {
          this.isLoadingNews = false;
        });
    },

    goProfile() {
      this.$router.push('/profile');
    },
    goRegister() {
      this.$router.push('/register');
    },
    seeDetail(id) {
      this.$router.push('/product/detail/' + id);
    },
    seeAuction(id) {
      this.$router.push('/product/auction/' + id);
    },
    getListAuctionDo() {
      this.isLoadingAuction = true;
      Auction.getListAuction({ typeId: CONFIG.ID_AUCTION_DO, pageIndex: 1, pageSize: 10 })
        .then(({ data }) => {
          this.auctionDoData = data.Data.Data;
        })
        .finally(() => {
          this.isLoadingAuction = false;
        });
    },
    onViewAllNewsNotify() {
      this.$router.push('/news');
    },
    onViewAllAuction() {
      this.$router.push('/auctions');
    }
  }
};
</script>

<style scoped>
.inner-bottom {
  width: 50%;
  height: 2px;
  margin: 0px auto;
  border-bottom: 1px solid #efefef;
}

.view-all {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

@media screen and (max-width: 600px) {
  .view-all-top {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard.vue